import Link from "next/link";
import React from "react";
import { ImageWrapper, LinkButton, Text } from "ui-components";

import { AgencyCard } from "@/hooks/api/generated";
import { useCurrentLocale } from "@/hooks/useCurrentLocale";
import { PLACEHOLDER_IMAGE } from "@/src/constants/images";

export default function ClientCard({
  agent,
}: {
  agent: AgencyCard;
}): JSX.Element {
  const currentLocale = useCurrentLocale();
  const logoImageUrl = Array.isArray(agent.organizationImage)
    ? agent.organizationImage.find((img) => img?.image?.type === "logo")?.image
        ?.public_id
    : undefined;

  return (
    <div className="w-full sm:w-1/2 md:w-1/2 lg:w-1/3 px-[5px] py-2.5">
      <div className="relative">
        <div className="w-full min-h-[250px] rounded-[10px] border hover:shadow-lg overflow-hidden">
          <div className="p-5 flex flex-col gap-2 items-center">
            <div className="w-full flex items-center gap-4">
              <Link href={`/${currentLocale}/organizations/${agent.slug}`}>
                <ImageWrapper
                  src={logoImageUrl}
                  placeholderUrl={PLACEHOLDER_IMAGE}
                  width={68}
                  height={68}
                  alt="Picture of the logo"
                  className="rounded-[10px] w-[68px] h-[68px] border"
                  style={{
                    objectFit: "cover",
                  }}
                  isCLDImage
                />
              </Link>
              <div className="flex flex-col gap-1">
                <Link href={`/${currentLocale}/organizations/${agent.slug}`}>
                  <Text variant="large" className="!font-bold">
                    {agent.name}
                  </Text>
                </Link>
              </div>
            </div>
            <div className="w-full flex items-center justify-between gap-4 mt-4">
              <Text className="text-left">Active Jobs</Text>
              <Text className="text-right">{agent.stats.activeJobs}</Text>
            </div>
            <div className="w-full flex items-center justify-between gap-4 mt-2">
              <Text className="text-left">Job Views</Text>
              <Text className="text-right">{agent.stats.jobViews}</Text>
            </div>
            <div className="w-full flex items-center justify-between gap-4 mt-2">
              <Text className="text-left">Clicks on Apply</Text>
              <Text className="text-right">{agent.stats.clicksOnApply}</Text>
            </div>
          </div>
          <div className="px-6">
            <LinkButton
              className="my-4 w-full h-10"
              href={`organizations/${agent.slug}/agency`}
            >
              <Text>View Client</Text>
            </LinkButton>
            <LinkButton
              className="my-4 w-full h-10 bg-white border border-black"
              href={`organizations/${agent.slug}/create-job`}
            >
              <Text>Post a Job</Text>
            </LinkButton>
          </div>
        </div>
      </div>
    </div>
  );
}
